<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    <sb-form-field-label [formField]="formField"></sb-form-field-label>
    <div class="w-100">
        <input
            type="text"
            id="form-element-{{ formField.id }}"
            class="form-control"
            autocomplete="off"
            name="formField{{ formField.id }}"
            appFocus
            [appAutoFocus]="formField.isNeedToFocus"
            [placeholder]="formField.placeholder"
            [required]="formField.isRequired"
            [(ngModel)]="formField.value"
            appWhitespaceValidator
            [needToCheck]="formField.isRequired"
            maxlength="1000" />
        <!--        todo: check this condition, it can be simplier?-->
        @if (formService.isSubmitted && formField.isRequired && !(formField.value && formField.value.trim())) {
            <div class="text-danger" translate>Please fill this field</div>
        }
    </div>
</div>
